export class InternalPresetting {
  constructor(
    public hash?: string,
    public name?: string,
    public code?: string,
    public active?: boolean
  ) { }

  clone() {
    return new InternalPresetting (
      this.hash,
      this.name,
      this.code,
      this.active
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/internal-presetting.ts